import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  margin: 20px 0;
  @media print {
    page-break-inside: avoid;
  }
`;

export const StyledDetails = styled.div`
  flex-grow: 1;
  margin-left: 10px;
`;

export const StyledQuantity = styled.span`
  font-size: 14px;
  line-height: 1.28;
`;
